export default __webpack_public_path__ + "alberta-hammer.ad5b22516ca3986f9a91.svg";